import { ProductLine, BookingAvailabilityModeValue } from '@kouto/types';
import React from 'react';
import styled from 'styled-components';
import getSameMonthDateLabels from 'features/LandingPage/getSameMonthDateLabels';
import { useFormatPrice } from 'utils/listingsHelpers';
import { PublicListingV3 } from 'types/listingV3';
import { useTranslation } from 'react-i18next';

const DetailsLabel = styled.span`
  font-size: 14px;
  line-height: 16px;
  color: var(--way-colors-contrastColorShades-80);
`;

interface ListingItemCardDetailsLabelProps {
  advertisedPrice?: PublicListingV3['advertisedPrice'];
  bookingAvailabilityMode?: BookingAvailabilityModeValue | null;
  dates?: Date[] | null;
  hidePrice?: boolean | null;
  maxParticipants?: number | null;
  productLine: PublicListingV3['productLine'];
  showYear?: boolean;
  startingPrice: PublicListingV3['startingPrice'];
}

const ListingItemCardDetailsLabel = ({
  advertisedPrice,
  bookingAvailabilityMode,
  dates,
  hidePrice,
  maxParticipants,
  productLine,
  showYear,
  startingPrice,
}: ListingItemCardDetailsLabelProps) => {
  const { t: translate } = useTranslation();
  const priceDisplay = useFormatPrice({
    advertisedPrice,
    bookingAvailabilityMode,
    maxParticipants,
    startingPrice,
  });

  const dateLabels = getSameMonthDateLabels(dates);
  // eslint-disable-next-line no-nested-ternary
  const displayedDate = dateLabels
    ? showYear
      ? `${dateLabels?.month} ${dateLabels?.day}, ${dateLabels?.year}`
      : `${dateLabels?.month} ${dateLabels?.day}`
    : '';

  return (
    <DetailsLabel className="listing-card-details">
      {productLine === ProductLine.ACTIVATE &&
        displayedDate &&
        `${displayedDate} • `}
      {!hidePrice && !!startingPrice && `${translate('fromListingCard')} `}
      {!hidePrice && priceDisplay}
    </DetailsLabel>
  );
};

export default ListingItemCardDetailsLabel;
